import {Component} from 'react'

export default class DiagnosticErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = {error: null, info: null}
    }

    static getDerivedStateFromError(error) {
        return {error}
    }

    componentDidCatch(error, info) {
        console.error('[DiagnosticErrorBoundary] caught', {
            name: error?.name,
            message: error?.message,
            stack: error?.stack,
            componentStack: info?.componentStack,
        })
        this.setState({info})
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{padding: 24, fontFamily: 'monospace', whiteSpace: 'pre-wrap', background: '#fff3f3', color: '#7a0000', minHeight: '100vh'}}>
                    <h2 style={{marginTop: 0}}>Error — see console for details</h2>
                    <p><strong>{this.state.error?.name}:</strong> {this.state.error?.message}</p>
                    <p><strong>Component stack:</strong></p>
                    <pre style={{fontSize: 12, background: '#fff', padding: 12, borderRadius: 4}}>{this.state.info?.componentStack || '(none)'}</pre>
                </div>
            )
        }
        return this.props.children
    }
}
